<template>
  <div class="d-flex flex-column ga-8">
    <div class="d-flex flex-column ga-4">
      <div class="d-flex flex-column ga-4 lgpd-box">
        <div
          v-for="(signature, index) in localData.signaturesConfig"
          :key="`signature-type-1-${index}`"
          class="d-flex flex-column ga-4"
        >
          <h2 class="title-medium">Consentimento de comunicação</h2>
          <RbRichTextEditor
            v-model="signature.acceptanceText"
            label="Texto para consentimento de comunicação"
            required
          />
          <h3 class="title-medium">
            Confirmação escrita de consentimento para comunicações
          </h3>
          <div class="signature-type-row">
            <rb-select
              v-model="signature.crmSignatureId"
              :items="getAvailableSignatureOptions(index)"
              item-title="title"
              item-value="id"
              label="Tipo de assinatura"
              :rules="[...props.inputRules.required]"
              required
              inline
              class="flex-grow-1"
              hide-details
            />
            <v-btn
              v-if="localData.signaturesConfig.length > 1"
              variant="text"
              color="neutral-35"
              class="remove-signature-btn px-6 py-5 d-flex"
              :icon="'mdi-minus'"
              rounded="xl"
              v-tooltip="'Remover assinatura'"
              @click="removeSignatureConfiguration(index)"
            >
              <v-icon size="20">mdi-minus</v-icon>
            </v-btn>
          </div>

          <rb-input
            v-model="signature.acceptanceKeyword"
            label="Mensagem de confirmação *"
            :rules="[...props.inputRules.required]"
            required
          />

          <rb-input
            v-model="signature.rejectionKeyword"
            label="Mensagem de negação *"
            :rules="[...props.inputRules.required]"
            required
          />

          <rb-switch
            v-model="signature.required"
            label="Tornar este campo obrigatório."
          />
        </div>

        <v-btn
          prepend-icon="mdi-plus"
          rounded="xl"
          variant="text"
          color="primary-35"
          class="align-self-start px-4"
          @click="addSignatureConfiguration"
        >
          Adicione nova confirmação de consentimento
        </v-btn>
      </div>
    </div>

    <div class="d-flex flex-column ga-4">
      <h2 class="title-medium">Consentimento de privacidade</h2>

      <div class="lgpd-box d-flex flex-column ga-4">
        <rb-select
          v-model="localData.legalBasisConfig.crmLegalBasisId"
          :items="localData.crmLegalBasisOptions"
          item-title="title"
          item-value="id"
          label="Tipo de base legal para processar"
          :rules="[...props.inputRules.required]"
          required
          inline
        />

        <RbRichTextEditor
          v-model="localData.legalBasisConfig.privacyText"
          label="Texto de privacidade"
          required
        />

        <rb-input
          v-model="localData.legalBasisConfig.acceptanceKeyword"
          label="Mensagem de confirmação *"
          :rules="[...props.inputRules.required]"
          required
        />

        <rb-input
          v-model="localData.legalBasisConfig.rejectionKeyword"
          label="Mensagem de negação *"
          :rules="[...props.inputRules.required]"
          required
        />

        <RbRichTextEditor
          v-model="localData.legalBasisConfig.acceptanceText"
          label="Texto de consentimento para processar"
          required
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import RbRichTextEditor from '@/ai_studio/components/common/RbRichTextEditor.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  inputRules: {
    type: Object,
    required: true
  }
});

const localData = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue);
  }
});


const addSignatureConfiguration = () => {
  localData.value.signaturesConfig.push({
    crmSignatureId: null,
    acceptanceText: '',
    acceptanceKeyword: '',
    rejectionKeyword: '',
    required: true
  });
};

const removeSignatureConfiguration = (index) => {
  if (localData.value.signaturesConfig.length <= 1) return;
  localData.value.signaturesConfig.splice(index, 1);
};

const getAvailableSignatureOptions = (currentIndex) =>
  localData.value.crmSignatureOptions.filter((option) =>
    !localData.value.signaturesConfig.some((signature, index) =>
      index !== currentIndex && signature.crmSignatureId === option.id
    )
  );
</script>

<style lang="scss" scoped>
.lgpd-box {
  border: 1px solid rgb(var(--v-theme-neutral-80));
  border-radius: 8px;
  padding: 16px;
}

.signature-type-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.remove-signature-btn {
  min-width: 32px;
  width: 32px;
  height: 40px;
  padding: 0;
  font-size: 24px;
}
</style>
